import React from "react";

function FooterCopyright() {
  return (
    <div className="copyright">
      <p>
        {new Date().getFullYear()} © Falcon Beverly Hills LLC ·{" "}
        <a href="/privacy-policy" target="_blank">
          Privacy
        </a>{" "}
        ·{" "}
        <a href="/terms-and-conditions" target="_blank">
          Terms
        </a>{" "}
        ·{" "}
        <a href="/sitemap" target="_blank">
          Sitemap
        </a>
      </p>
    </div>
  );
}

export default FooterCopyright;
